import { Component, EventEmitter, Input, Output } from "@angular/core";
import { runInThisContext } from "vm";
import { ReportDesignerItemTitleValue } from "../../report-design-item";

@Component({
  selector: "snt-report-form-renderer-title",
  templateUrl: "report-form-renderer-title.component.html",
  styles: [
    `
      :host {
        display: flex;
      }
    `
  ],
  standalone: false
})
export class ReportFormRendererTitleComponent {
  @Input() item!: ReportDesignerItemTitleValue;
  @Input() level!: number;
  @Input() parentName!: string;

  @Output() value: EventEmitter<{}> = new EventEmitter();

  get size(): string {
    switch (this.item?.config?.size) {
      case "h1":
        return "text-5xl";
      case "h2":
        return "text-4xl";
      case "h3":
        return "text-3xl";
      case "h4":
        return "text-2xl";
      case "h5":
        return "text-xl";
      default:
        return "text-xl";
    }
  }

  get alignment(): string {
    switch (this.item?.config?.alignment) {
      case "center": {
        return "text-center";
      }
      case "right": {
        return "text-right";
      }
      default:
        return "text-left";
    }
  }

  get fontWeight(): string {
    switch (this.item?.config?.fontWeight) {
      case "extrabold": {
        return "font-extrabold";
      }
      case "bold": {
        return "font-bold";
      }
      case "semibold": {
        return "font-semibold";
      }
      case "medium": {
        return "font-medium";
      }
      case "normal": {
        return "font-normal";
      }
      case "light": {
        return "font-light";
      }
      case "extralight": {
        return "font-extralight";
      }
      case "thin": {
        return "font-thin";
      }
      default:
        return "font-normal";
    }
  }

  async renderPdfObject(): Promise<Record<string, any>> {
    return {
      type: "title",
      titleValue: this.item?.config?.title || "",
      size: this.item?.config?.size || "text-xl",
      alignment: this.item?.config?.alignment || "left"
    };
  }
}
